module.exports = __webpack_public_path__ + "static/carbon_card-8c3aa3f3ab6263b79383124bd6a1a41f.jpg";